export default {
  "language": "sw",
  "message":
    {
      "title": "Mchanganyiko mapato makazi ziada calculator",
      "zoningDistrict": "Chagua wilaya ya kugawa maeneo",
      "affordabilityLevel": "Chagua kiwango cha uwezo",
      "allThatApply": "Chagua yote yanayotumika.",
      "springGardenS": "Je! Mradi huo uko kusini mwa Spring Garden Street?",
      "yes": "Ndio",
      "no": "Hapana",
      "affordability": {
        "lowIncome": "Mapato ya chini",
        "moderateIncome": "Mapato ya wastani",
      },
      "lotAreaSqft": "Ingiza eneo lolote katika futi za mraba",
      "buildingHeight": "Ingiza Urefu wa Jengo",
      "totalUnits": "Idadi iliyopendekezwa ya vitengo katika mradi:",
      "unitsEarnedLow": "Vitengo vya Ziada Vilivyopatikana (Mapato ya Chini):",
      "unitsEarnedMod": "Vitengo vya Ziada Vilivyopatikana (Mapato ya Wastani):",
      "greenRoofBonus": "Idadi ya Vitengo vya Bonasi ya Paa la Kijani:",
      "modIncomePayment": "Makadirio ya Mapato ya Wastani:",
      "lowIncomePayment": "Malipo ya Makadirio ya Mapato ya Chini:",
      "requiredAffordableUnits": "Vitengo vya bei rahisi vya MIHB vinavyo:",
      "requiredMinAffordableUnits": "Inahitajika/MIN Vitengo vya bei nafuu:",
      "totalRequiredAffordabilityUnits": "Jumla ya Vitengo vya bei nafuu vinavyohitajika:",
      "additionalFar": "Ziada FAR chuma:",
      "totalFar": "Jumla ya FAR:",
      "totalFloor": "Jumla ya Eneo la Sakafu Inaruhusiwa:",
      "overlay": {
        "fithDistrict": "Mradi huu uko ndani ya Wilaya ya Tano ya Kufunika (/VDO).",
        "greenRoof": "Mradi huu utapata Bonasi ya Paa la Kijani.",
        "minMixed": "Mradi huu uko ndani ya /MIN Mchanganyiko wa Vitongoji vya Mapato Mchanganyiko.",
        "todDevelopement": "Mradi huu uko ndani ya/TOD Transit Oriented Development Overlay.",
      },
      "sFHA": [
        "Maalum Mafuriko Hatari Area",
      ],
      "numberOfDwellingUnits": "Idadi ya Vitengo vya Makazi vinavyoruhusiwa Chini ya Ukanda wa Msingi",
      "about": "Kuhusu",
      "aboutTitle": "Kuhusu ziada ya makazi ya mapato mchanganyiko",
      "aboutSubTitle": "Jinsi ya kutumia calculator",
      "paragraphOne": "Bonasi ya makazi ya mapato mchanganyiko ni kwa watengenezaji ambao huongeza makao ya bei nafuu kwa miradi yao au kulipa katika mfuko unaounga mkono nyumba za bei nafuu. Kwa kurudi, maendeleo hupata eneo la sakafu zaidi la “kulia”, urefu, na/au vitengo vya makao. Waendelezaji wanaweza kuchagua kutoka ngazi mbili za ziada. Kiwango cha wastani cha mapato ni bonasi ndogo, lakini ina viwango vya chini vya ufikiaji au kiwango cha chini cha malipo. Kiwango cha mapato ya chini ni bonasi kubwa, lakini ina viwango vikali vya ufikiaji au kiwango cha juu cha malipo.",
      "paragraphTwo": {
        "text": "Kikokotoo cha ziada cha makazi ya mapato mchanganyiko hutumiwa kukadiria kwa usahihi:",
        "bullets": [
          "Jumla ya idadi ya vitengo vinavyoruhusiwa.",
          "Jumla ya idadi ya vitengo vya bei nafuu ambavyo utahitajika kutoa.",
          "Ada badala ya kiasi kulipwa kwa ajili ya maendeleo ambayo inatumia mchanganyiko mapato ya makazi ya ziada.",
        ],
      },
      "paragraphThree": {
        "text": "Ili kuanza, chagua wilaya ya ukanda wa msingi wa mali na uingie eneo lake la kura. Unapaswa pia kuchagua wilaya zozote zinazofaa za kufunika. Unaweza kutumia",
        "link": {
          "text": "Atlas",
          "p": {
            "url": "https://atlas.phila.gov/",
          },
        },
        "continuation": "ili kupata habari hii.",
      },
      "finalConfirmation": "Kikokotoo hii itatumika kwa upangaji wa mradi wa dhana. Ambapo kuna tofauti kati ya kihisabu na Kanuni ya Ukoaji wa Philadelphia, Kanuni ya Ukoaji wa Philadelphia itatawala. Uthibitisho wa mwisho wa vitengo, idadi inayohitajika ya vitengo vya bei nafuu, na/au ada badala ya kiasi itafanywa na wafanyikazi wa Tume ya Mipango ya Jiji la Philadelphia wakati wa ukaguzi wa idh.",
      "resources": "Rasilimali",
      "code1": {
        "link": {
          "text": "Nambari ya Philadelphia - 14-702 (7) - Bonasi ya Makazi ya Mapato Mchanganyiko",
          "p": {
            "url": "https://codelibrary.amlegal.com/codes/philadelphia/latest/philadelphia_pa/0-0-0-293117",
          },
        },
      },
      "code2": {
        "link": {
          "text": "Nambari ya Philadelphia - 14-533 - Wilaya ya Ufunikaji wa Mapato Mchanganyiko",
          "p": {
            "url": "https://codelibrary.amlegal.com/codes/philadelphia/latest/philadelphia_pa/0-0-0-291906",
          },
        },
      },
      "facts": {
        "link": {
          "text": "Karatasi za ukweli za ziada za mapato ya ziada",
          "p": {
            "url": "https://www.phila.gov/documents/affordable-housing-zoning-bonus-review-application/",
          },
        },
      },
    },
};